/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface ExecuteGraphRequest200Response
 */
export interface ExecuteGraphRequest200Response {
    /**
     * 
     */
    message?: string;
    /**
     * Response data from Microsoft Graph API
     */
    data?: any | null;
}

/**
 * Check if a given object implements the ExecuteGraphRequest200Response interface.
 */
export function instanceOfExecuteGraphRequest200Response(value: object): value is ExecuteGraphRequest200Response {
    return true;
}

export function ExecuteGraphRequest200ResponseFromJSON(json: any): ExecuteGraphRequest200Response {
    return ExecuteGraphRequest200ResponseFromJSONTyped(json, false);
}

export function ExecuteGraphRequest200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteGraphRequest200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] === undefined ? undefined : json['data'] === null ? null : json['data'],
    };
}

export function ExecuteGraphRequest200ResponseToJSON(json: any): ExecuteGraphRequest200Response {
    return ExecuteGraphRequest200ResponseToJSONTyped(json, false);
}

export function ExecuteGraphRequest200ResponseToJSONTyped(value?: ExecuteGraphRequest200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'data': value['data'],
    };
}

